import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Customers } from "../customers/customers.entity";

@Entity('shipping_terms')
export class ShippingTerms {

  @PrimaryGeneratedColumn("increment",{name:'shipping_term_id'})
  shippingTermsId:number;
  
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"shipping_term_name"
      })
  // @Index({unique:true})
  shippingTermsName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  // @OneToMany(type=>Customers, customers=>customers.shipmentTerms,{cascade: true})
  // customerInfo:Customers[];
}
